import { FC } from 'react';

import Blackout from '../custom/blackout/blackout';

import Close from '../../assets/icons/close.svg';

import styles from './errorsModal.module.scss';

interface IErrorsModalOptions {
  title: string;
  onClose: () => void;
  content: string;
}

const ErrorsModal: FC<IErrorsModalOptions> = ({ onClose, title, content }) => {
  const arrContent = content
    .split('Строка ')
    .filter((elem: string) => elem !== '');

  return (
    <>
      <Blackout onClose={onClose}>
        <div
          onClick={(event: React.MouseEvent) => event.stopPropagation()}
          className={styles.modal}
        >
          <div className={styles.title__block}>
            <span>{title}</span>
            <img
              style={{ cursor: 'pointer' }}
              onClick={onClose}
              src={Close}
              alt='close'
            />
          </div>
          <div className={styles.roles__block}>
            <div className={styles.button__block}>
              <div className={styles.roles__table}>
                <div className={styles.roles__list}>
                  {content &&
                    arrContent.map((elem: string, index: number) => (
                      <span key={index}>
                        Строка{' '}
                        {index === arrContent.length - 1
                          ? elem
                          : elem.slice(0, -1)}
                        .
                      </span>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Blackout>
    </>
  );
};

export default ErrorsModal;
